import { useEffect } from 'react'

import { useCurrentUser } from '@modules-deprecated/app/user'

import { useBraze } from './useBraze'

export const useSetBrazeUserIdentity = () => {
  const { setUserIdentity } = useBraze()
  const { user } = useCurrentUser()

  useEffect(() => {
    if (user) {
      setUserIdentity({
        name: user.name,
        locale: user.locale,
        globalId: user.globalId,
        email: user.email,
      })
    }
  }, [user, setUserIdentity])
}
